import { constantRouterMap } from '@/router/index'
import Layout from '../../views/menu/Layout'
const _import = require('../../router/_import_' + process.env.NODE_ENV)
let optionChild = null
let option = null
let accessedRouters = []

const permission = {
  state: {
    menu: [],
    routers: constantRouterMap, // 本用户所有的路由,包括了固定的路由和下面的addRouters
    addRouters: [] // 本用户的角色赋予的新增的动态路由
  },
  mutations: {
    SET_Menu: (state, routers) => {
      state.menu = routers
      console.log('菜单', state.menu)
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers) // 将固定路由和新增路由进行合并, 成为本用户最终的全部路由信息
    }
  },
  actions: {
    GenerateRoutes({ commit }, userMenuTree) {
      // 生成路由
      return new Promise(resolve => {
        // 此处每次改变菜单都需要来维护，修改对应的逻辑
        // （不修改代码的情况下菜单改变只支持菜单禁用和菜单从当前目录调整到同级的目录中，不可调整到其他的菜单下，会导致菜单不可用）
        // userMenuTree是后台传过来的菜单树，在这里转化为前端用的路由
        const menus = userMenuTree
        menus.forEach((item, index) => {
          switchCaseMenuDirectory(item)
        })
        let menu = JSON.parse(JSON.stringify(accessedRouters))
        commit('SET_Menu', menu)
        accessedRouters = delteFakeParent(accessedRouters)
        // 执行设置路由的方法
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}
function switchCaseMenuDirectory(item) {
  switch (item.funCode) {
    // 这里设置菜单目录，格式不同
    case 'home': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'home',
        children: [
          {
            path: 'home',
            component: () => import('@/views/home/index'),
            name: 'Home',
            meta: { title: '首页', icon: 'home', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'quota_management': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'quota_management',
        children: [
          {
            path: 'quota_management',
            component: () => import('@/views/quota_management'),
            name: 'QuotaManagement',
            meta: { title: '限额管理', icon: 'quota_management', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'alarm_value_management': // 单页设置
      option = {
        id: item.id,
        parentId: item.parentId,
        path: '/',
        component: Layout,
        menu: 'alarm_value_management',
        children: [
          {
            path: 'alarm_value_management',
            component: () => import('@/views/alarm_value_management'),
            name: 'AlarmValueManagement',
            meta: { title: '报警值管理', icon: 'alarm_value_management', noCache: true }
          }
        ]
      }
      pushMenu(item, option)
      break
    case 'user_permissions':
      option = { // 一级父级
        id: item.id,
        parentId: item.parentId,
        path: '/user_permissions',
        component: Layout,
        redirect: '/user_permissions/',
        meta: { title: '账户管理', icon: 'user_permissions' },
        children: []
      }
      pushMenu(item, option)
      break
  }
}
function pushMenu(item, option) {
  if (item.children.length > 0) {
    item.children.forEach(val => {
      if (val.children.length === 0) {
        // 这里设置菜单
        switchCaseMenu(val.funCode)
        option.children.push(optionChild)
      } else {
        accessedRouters.push(option)
        switchCaseMenuDirectory(val)
      }
    })
  }
  if (option.parentId === null) {
    if (accessedRouters.indexOf(option) === -1) {
      accessedRouters.push(option)
    }
  } else {
    accessedRouters.forEach((j) => {
      if (j.id === item.parentId) {
        j.children.push(option)
      }
    })
  }
}
function switchCaseMenu(item) {
  let option = null
  switch (item) { // 子级
    // 设置菜单
    case 'user':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'user',
        name: 'User',
        meta: { title: '用户管理', icon: 'user', noCache: false },
        component: _import('user_permissions/user'),
        menu: 'user'
      }
      optionChild = option
      break
    case 'organization':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'organization',
        name: 'Organization',
        meta: { title: '组织管理', icon: 'orangnization', noCache: false },
        component: _import('user_permissions/organization'),
        menu: 'organization'
      }
      optionChild = option
      break
    case 'role':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'role',
        name: 'Role',
        meta: { title: '角色管理', icon: 'role', noCache: false },
        component: _import('user_permissions/role'),
        menu: 'role'
      }
      optionChild = option
      break
    case 'function':
      option = {
        id: item.id,
        parentId: item.parentId,
        path: 'function',
        name: 'Function',
        meta: { title: '功能管理', icon: 'function', noCache: false },
        component: _import('user_permissions/function'),
        menu: 'function'
      }
      optionChild = option
      break
  }
}
function delteFakeParent(router) {
  for (let i = 0; i < router.length; i++) { // 一级遍历
    if (router[i].children.length) { // 如果一级下还有二级
      for (let j = 0; j < router[i].children.length; j++) { // 二级遍历
        if (router[i].children[j].children && router[i].children[j].children.length) {
          router[i].children[j].children.forEach(val => {
            router[i].children.push(val)
          })
          router[i].children.splice(j, 1)
          j--
        }
      }
    }
  }
  return router
}
export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js